import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[580px] md:h-[680px] w-full flex items-center overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20flatlay%20photography%20of%20cream%20knit%20sweater%20white%20leather%20sneakers%20artisan%20tote%20bag%20and%20delicate%20gold%20accessories%20arranged%20on%20warm%20oatmeal%20linen%20fabric%20soft%20natural%20window%20light%20casting%20gentle%20diagonal%20shadows%20clean%20Scandinavian%20aesthetic%20with%20organic%20textures%20and%20negative%20space%20elegant%20product%20composition&width=1800&height=900&seq=hero-main-fresh-v3&orientation=landscape"
        alt="Hoobuyspreadsheet lifestyle editorial"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-[680px]">
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-[1.05] tracking-tight">
            <span className="block">{t("hero.line1")}</span>
            <span className="block italic font-light text-white/80">{t("hero.line2")}</span>
            <span className="block">{t("hero.line3")}</span>
          </h1>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-accent-500/80 backdrop-blur-sm text-white font-semibold text-base hover:bg-accent-600/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      {/* Bottom tagline */}
      <div className="absolute bottom-0 left-0 w-full z-10 px-6 pb-10 md:pb-14">
        <p className="font-heading text-5xl md:text-8xl lg:text-9xl font-black text-white/12 leading-none select-none">
          {t("hero.tagline")}
        </p>
      </div>
    </section>
  );
}